// 本地扫描历史：localStorage 持久化
const DEFAULT_KEY = 'qr_scan_history_v1';
const MAX = 50;

export class HistoryStore {
    constructor(key = DEFAULT_KEY, max = MAX) {
        this.key = key;
        this.max = max;
        this.items = this._load();
    }

    _load() {
        try {
            const s = localStorage.getItem(this.key);
            return s ? JSON.parse(s) : [];
        } catch {
            return [];
        }
    }

    _save() {
        try {
            localStorage.setItem(this.key, JSON.stringify(this.items));
        } catch {}
    }

    add(item) {
        if (this.items.length && this.items[0].content === item.content) {
            this.items[0].timestamp = item.timestamp;
        } else {
            this.items.unshift(item);
        }
        if (this.items.length > this.max) {
            this.items = this.items.slice(0, this.max);
        }
        this._save();
    }

    getAll() {
        return [...this.items];
    }

    clear() {
        this.items = [];
        this._save();
    }
}
